import React from "react";
import AuthorityNavbar from "../header/AuthorityNavbar";

const AuthorityLayout = ({ children }) => {
  return (
    <main className="w-full min-h-screen relative bg-gray-100 ">
      <AuthorityNavbar />
      <div className="py-5 px-5 md:py-8 md:px-8 lg:py-10 lg:px-12 xl:px-20">
        {children}
      </div>
    </main>
  );
};

export default AuthorityLayout;
